import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getInventoryShort } from './api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<number>, 'enabled'>;

export default function useInventoryShort(inventoryId: number, options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data: inventory, isFetching } = useQuery(
    ['inventories', inventoryId],
    () => getInventoryShort(inventoryId),
    {
      enabled: false,
      onError: error => {
        toast.error(t('message.title.error.get.inventory'));
      },
      ...options,
    }
  );

  return { file: inventory, isFetching, getInventoryShort };
}
